import install from './install.js'
const version = '__VERSION__'

export default {
  version,
  install
}
